import { booleanAttribute, Component, input, output, signal, viewChild } from "@angular/core";
import { FormsModule, NgForm, ReactiveFormsModule } from "@angular/forms";
import { VdsButtonComponent } from "@cce/design-system/button";
import { VdsCheckbox } from "@cce/design-system/checkbox";
import { VdsErrorComponent } from "@cce/design-system/form-field";
import { VdsIconComponent } from "@cce/design-system/icon";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
    selector: "vo-shell-tos-form",
    templateUrl: "./tos-form.component.html",
    host: {
        class: "contents"
    },
    imports: [ReactiveFormsModule, VdsButtonComponent, VdsCheckbox, TranslocoDirective, FormsModule, VdsErrorComponent, VdsIconComponent]
})
export class TosFormComponent {
    private form = viewChild(NgForm);

    public submitted = signal<boolean>(false);

    public disabled = input(true, { transform: booleanAttribute });

    public updating = input<boolean>(false);

    public termsAccepted = output<void>();

    public submit(): void {
        if (this.form()?.valid && !this.submitted()) {
            this.submitted.set(true);
            this.termsAccepted.emit();
        }
    }
}
